var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.id}},[_c('ProgressControl',{ref:"progress",attrs:{"map":_vm.map}}),_c('TextControl',{attrs:{"text":_vm.help,"map":_vm.map}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }